import React from 'react';
import { useTranslation } from 'react-i18next';
import Styles from './Styles.module.css';

const Footer = ({
  onAddParticipants,
  onScreenShare,
  screenShare,
  onLeaveCall,
  onToggleMic,
  onToggleVideo,
  micOn = true,
  videoOn = true,
  onPanelTabClick,
  rightPanelOpen,
  rightPanelTab,
}) => {
  const { t } = useTranslation();
  const panelTabs = [
    { id: 'chat', label: t('screens.video.group.tabChat') },
    { id: 'people', label: t('screens.video.group.tabPeople') },
    { id: 'notes', label: t('screens.video.group.tabNotes') },
    { id: 'files', label: t('screens.video.group.tabFiles') },
  ];

  return (
    <div className={Styles.footer}>
      {/* Left — secondary controls */}
      <div className={Styles.leftGroup}>
        <div className={Styles.ctlBtn} onClick={onAddParticipants} title={t('screens.video.group.addParticipants')}>
          <div className={Styles.ctlIconWrap}>
            <svg className={Styles.ctlIcon}>
              <use xlinkHref="/assets/sprite.svg#icon-add-participant" />
            </svg>
          </div>
          <span className={Styles.ctlLabel}>{t('screens.video.group.addPeople')}</span>
        </div>
        <div
          className={`${Styles.ctlBtn} ${screenShare ? Styles.ctlActive : ''}`}
          onClick={onScreenShare}
          title={screenShare ? t('screens.video.group.stopSharing') : t('screens.video.group.shareScreenTitle')}
        >
          <div className={Styles.ctlIconWrap}>
            <svg className={Styles.ctlIcon} style={{ height: '1.5rem', width: '1.8rem' }}>
              <use xlinkHref="/assets/sprite.svg#icon-share-screen" />
            </svg>
          </div>
          <span className={Styles.ctlLabel}>{screenShare ? t('screens.video.group.stopShare') : t('screens.video.group.shareScreen')}</span>
        </div>
      </div>

      {/* Center — primary controls */}
      <div className={Styles.centerGroup}>
        <div
          className={`${Styles.iconCircle} ${!micOn ? Styles.iconRed : ''}`}
          onClick={onToggleMic}
          title={micOn ? t('screens.video.group.mute') : t('screens.video.group.unmute')}
        >
          <svg><use xlinkHref={`/assets/sprite.svg#icon-${micOn ? 'unmute' : 'mute'}`} /></svg>
        </div>
        <div
          className={`${Styles.iconCircle} ${!videoOn ? Styles.iconRed : ''}`}
          onClick={onToggleVideo}
          title={videoOn ? t('screens.video.group.stopCamera') : t('screens.video.group.startCamera')}
        >
          <svg><use xlinkHref={`/assets/sprite.svg#icon-video-${videoOn ? 'on' : 'off'}`} /></svg>
        </div>
        <div
          className={`${Styles.iconCircle} ${Styles.iconRedAlways}`}
          onClick={onLeaveCall}
          title={t('screens.video.group.leaveCall')}
        >
          <svg style={{ height: '1.4rem', width: '1.4rem' }}>
            <use xlinkHref="/assets/sprite.svg#icon-hang-up" />
          </svg>
        </div>
      </div>

      {/* Right — panel tab toggles */}
      <div className={Styles.rightGroup}>
        {panelTabs.map(({ id, label }) => (
          <button
            key={id}
            className={`${Styles.panelTabBtn} ${rightPanelOpen && rightPanelTab === id ? Styles.panelTabActive : ''}`}
            onClick={() => onPanelTabClick && onPanelTabClick(id)}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Footer;
